module.exports = __webpack_public_path__ + "assets/fonts/ysbth.1726685c.TTF";